import * as types from '../mutation-types';
import { unionState, toDateTimeString } from '../helpers';
import VueRouter from 'vue-router';

const state = () => ({
    offers: [],
});

const actions = {
    fetchAll({ commit }) {
        return axios.get('/api/offers').then(response => {
            commit(types.STORE_OFFERS, response.data);

            return response.data;
        });
    },

    fetch({ commit }, { offersId }) {
        return axios.get(`/api/offers/${offersId}`).then(response => {
            commit(types.STORE_ONE_OFFER, response.data);

            return response.data;
        });
    },

    create({ commit }, { product_id, start, end, new_price, notes }) {
        const formData = new FormData();
        formData.append('product_id', product_id);
        formData.append('start_date', start);
        formData.append('end_date', end);
        formData.append('new_price', new_price);
        formData.append('notes', notes);

        return axios.post(`/api/offers`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            commit(types.STORE_ONE_OFFER, response.data);

            return response.data;
        });
    },

    update({ commit }, { offersId , product_id, start, end, new_price, notes }) {
        const formData = new FormData();
        formData.append('product_id', product_id);
        formData.append('start_date', start);
        formData.append('end_date', end);
        formData.append('new_price', new_price);
        formData.append('notes', notes);

        formData.append('_method', 'PUT');

        return axios.post(`/api/offers/${offersId}`, formData, formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            commit(types.STORE_ONE_OFFER, response.data);

            return response.data;
        });
    },

    delete({ commit }, { offersId }) {
        return axios.delete(`/api/offers/${offersId}`).then(response => {
            commit(types.DELETE_ONE_OFFER, offersId);
        });
    },
};
const mutations = {
    [types.STORE_OFFERS](state, offers) {
        state.offers = unionState(state.offers, offers);
    },

    [types.STORE_ONE_OFFER](state, offer) {
        state.offers = unionState(state.offers, [offer]);
    },

    [types.DELETE_ONE_OFFER](state, id) {
		state.offers = state.offers.find(p => p.id !== id);
    },
};

const getters = {
    getById: state => id => state.offers.find(n => n.id === id),
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
